import React from 'react';

import EmptyState from '@atlaskit/empty-state';

const EmptyStateDefaultExample = (): React.JSX.Element => {
	return <EmptyState header="You don't have access to this work item" />;
};

export default EmptyStateDefaultExample;
